import { openapi_website_cms_updateMarketFiltersForSport, Response200Type, decodeResponse200 } from 'src/api_openapi/generated/openapi_website_cms_updateMarketFiltersForSport';
import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';

export type MarketFiltersType = Response200Type extends Array<infer Model> ? Model : never;

const decode = (status: number, data: ResponseType): Response200Type  => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface UpdateMarketFiltersForSportParams {
    filters: Array<MarketFilterUpdateParams>,
}

export interface MarketFilterUpdateParams {
    display_order: number,
    filter_id: number
}

export const updateMarketFiltersForSport = {
    browser: {
        params: (params: UpdateMarketFiltersForSportParams): ParamsFetchType<UpdateMarketFiltersForSportParams> => {
            return {
                type: MethodType.PATCH,
                url: '/api-web/update-market-filters',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.PATCH,
        urlBrowser: '/api-web/update-market-filters',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<UpdateMarketFiltersForSportParams>): Promise<GenerateUrlApiType> => {

        const resp = await openapi_website_cms_updateMarketFiltersForSport(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            body: params.req.body.filters
        });

        return {
            passToBackend: false,
            status: resp.status,
            responseBody: resp.body
        };
    }
};
